import { Component, HostListener } from '@angular/core';
import { CareSkill } from 'src/app/shared/models/employee/care-skill';
import { User } from 'src/app/shared/models/security/user';
import { SortOrder } from '../../beneficiaires/detail-beneficiaire/detail-beneficiaire.component';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Router } from '@angular/router';
import { FacadeService } from 'src/app/core/services/facade.service';
import { LogService } from 'src/app/core/services/log/log.service';
import { ErrorResponse } from 'src/app/shared/models/api-response/error-response';
import { ImportResponse } from 'src/app/shared/models/api-response/import-response';
import { CareskillModalAjoutComponent } from '../modal/careskill-modal-ajout/careskill-modal-ajout.component';
import { CareskillModalDetailComponent } from '../modal/careskill-modal-detail/careskill-modal-detail.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { GestionDonneesModule } from '../../gestion-donnees/gestion-donnees.module';
import {
	CompetencesElementaires,
	isElementarySkill
} from 'src/app/shared/enums/competence.enum';

@Component({
	selector: 'app-list-careskill',
	standalone: false,
	templateUrl: './list-careskill.component.html',
	styleUrl: './list-careskill.component.scss'
})
export class ListCareskillComponent {
	careSkills: CareSkill[] = [];
	currentPage = 1;
	itemsPerPage = 10;

	specialiteCsvFile: File = null;
	searchedSkill = '';
	searchedName = '';

	dismissible: true;
	alerts: any[] = [];

	nextWeekNumber: number;

	user: User = null;

	isAddable = false;
	isImportable = false;

	sortType = 'firstName';
	sortOrder: SortOrder = 'asc';

	searchedText: string;

	editSpecialiteModalRef: BsModalRef;
	addCareSkillModalRef: BsModalRef;
	screenWidth: number;
	isMobile: boolean = false;

	isListingLoading: boolean = true;

	constructor(
		private router: Router,
		private facade: FacadeService,
		private modalService: BsModalService,
		private logger: LogService
	) {}

	@HostListener('window:resize', ['$event'])
	onWindowResize() {
		this.screenWidth = window.innerWidth;
		if (this.screenWidth < 1200) {
			this.isMobile = true;
		} else {
			this.isMobile = false;
		}
	}

	ngOnInit(): void {
		this.screenWidth = window.innerWidth;
		this.isMobile =
			this.facade.mobileService.isMobile() || this.screenWidth < 1200;

		this.user = this.facade.dataStorageService.getUser();
		this.getCareSkills();
		if (this.facade.dataStorageService.isPlanificatrice()) {
			this.isAddable = true;
		}
	}

	getCareSkills(): void {
		this.isListingLoading = true;
		this.facade.careSkillService.getAllCareSkills().subscribe({
			next: (val) => {
				this.careSkills = val.filter((e) => e.name !== 'Sans');
				this.itemsPerPage = this.careSkills.length >= 8 ? 10 : 8;

				this.isListingLoading = false;
			},
			error: (err: ErrorResponse) => {
				this.logger.error(err + '');
				this.isListingLoading = false;
				this.careSkills = [];
			}
		});
	}

	selectSpecialite(careSkill: CareSkill): void {
		const link = ['/expertises', careSkill.id];
		this.router.navigate(link);
	}

	onClosed(dismissedAlert: any): void {
		this.alerts = this.alerts.filter((alert) => alert !== dismissedAlert);
	}

	openModalAjout() {
		this.addCareSkillModalRef = this.modalService.show(
			CareskillModalAjoutComponent,
			{
				class: 'modal-lg',
				backdrop: 'static'
			}
		);

		this.addCareSkillModalRef.onHide.subscribe((reason: string | any) => {
			this.getCareSkills();
		});
	}

	sortChange(str: string) {
		if (str === this.sortType) {
			if (this.sortOrder === 'asc') {
				this.sortOrder = 'desc';
			} else {
				this.sortOrder = 'asc';
			}
		} else {
			this.sortType = str;
			this.sortOrder = 'asc';
		}
	}

	isElementarySkill(careSkill: CareSkill) {
		return isElementarySkill(careSkill.name);
	}

	openModalEdit(careSkill: CareSkill) {
		if (!isElementarySkill(careSkill.name)) {
			const initialState = {
				careSkill: careSkill
			};
			this.editSpecialiteModalRef = this.modalService.show(
				CareskillModalDetailComponent,
				{
					class: '',
					initialState
				}
			);

			this.editSpecialiteModalRef.onHide.subscribe((reason: string | any) => {
				this.getCareSkills();
			});
		}
	}
}
